export default __webpack_public_path__ + "static/media/book_image1.66815476.jfif";